import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useBetaStatus = () => {
  return useQuery({
    queryKey: ['beta-status'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      console.log('[BetaStatus] Current user:', user?.id);
      
      if (!user) {
        console.log('[BetaStatus] No user, returning false');
        return { isInBeta: false, isActive: false };
      }

      // Check if beta program is active
      const { data: config, error: configError } = await supabase
        .from('beta_config')
        .select('is_active')
        .maybeSingle();

      console.log('[BetaStatus] Beta config:', config, 'Error:', configError);

      if (!config?.is_active) {
        console.log('[BetaStatus] Beta not active');
        return { isInBeta: false, isActive: false };
      }

      // Check if user is a beta participant
      const { data: participant, error: participantError } = await supabase
        .from('beta_participants')
        .select('*')
        .eq('user_id', user.id)
        .maybeSingle();

      console.log('[BetaStatus] Participant:', participant, 'Error:', participantError);

      const result = {
        isInBeta: !!participant && participant.is_active,
        isActive: config.is_active,
        participant
      };
      
      console.log('[BetaStatus] Final result:', result);
      return result;
    },
  });
};
